import { useMemo } from 'react';

const MAX_VISIBLE = 50;

export default function ResponseListDisplay({ slide, responses, participantCount }) {
  const sortedResponses = useMemo(() => {
    const items = responses
      .filter((r) => r.value && String(r.value).trim())
      .map((r) => ({
        id: r.id || r.participantId || Math.random().toString(36),
        value: String(r.value).trim(),
        submittedAt: r.submittedAt?.toDate?.() || r.submittedAt || new Date(0),
      }));

    items.sort((a, b) => {
      const ta = a.submittedAt instanceof Date ? a.submittedAt.getTime() : 0;
      const tb = b.submittedAt instanceof Date ? b.submittedAt.getTime() : 0;
      return tb - ta;
    });

    return items.slice(0, MAX_VISIBLE);
  }, [responses]);

  if (sortedResponses.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-4 w-full">
        <p className="text-blue-300 text-2xl animate-pulse">Inga svar enno...</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center w-full gap-4">
      <div
        className="w-full max-w-2xl max-h-[60vh] overflow-y-auto pr-2 space-y-3 scroll-smooth"
        style={{
          scrollbarWidth: 'thin',
          scrollbarColor: '#3b82f6 #1e293b',
        }}
      >
        {sortedResponses.map((r, i) => (
          <div
            key={r.id}
            className="bg-white/10 backdrop-blur-sm rounded-xl px-5 py-4 shadow-lg border border-blue-500/20"
            style={{
              animation: `slideInResponse 0.4s ease-out ${i * 0.06}s both`,
            }}
          >
            <p className="text-white text-lg leading-relaxed">{r.value}</p>
          </div>
        ))}
      </div>

      <p className="text-blue-300 text-lg">
        {responses.filter((r) => r.value && String(r.value).trim()).length} svar
      </p>

      <style>{`
        @keyframes slideInResponse {
          from {
            opacity: 0;
            transform: translateY(-12px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}
